import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  name: string;
  _type: string;
}
export const useCreateAddressType = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) => {
    return axios.post(
      `${env.verifyServiceUrl}individual/address_type/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
